import VRangeSlider from './VRangeSlider'

export { VRangeSlider }
export default VRangeSlider
